<div class="font-serif text-gray-900 min-h-screen bg-white">

  <!-- Breadcrumb -->
  <div class="bg-[#faf8f5] border-b border-gray-200 px-3 sm:px-6 md:px-12 py-2.5">
    <div class="max-w-[1100px] mx-auto flex items-center gap-2 text-[10px] sm:text-xs">
      <button (click)="router.navigate(['/'])" class="flex items-center gap-1 text-gray-600 hover:text-[#600b0b] font-bold uppercase tracking-[0.1em] transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
        Back
      </button>
      <span class="text-gray-300">|</span>
      <span class="text-gray-500">Custom Wallpaper</span>
      <span class="text-gray-300">/</span>
      <span class="text-[#600b0b] font-bold uppercase tracking-[0.1em]">AI Design</span>
    </div>
  </div>

  <!-- Main Content -->
  <div class="max-w-[1100px] mx-auto px-3 sm:px-6 md:px-12 py-5 sm:py-8">

    <!-- Two Column Layout -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-5 sm:gap-6">

      <!-- ═══ LEFT COLUMN ═══ -->
      <div class="flex flex-col gap-4 sm:gap-5">

        <!-- Reference Image -->
        <div>
          <div class="flex items-center gap-2 mb-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
            </svg>
            <h3 class="text-xs font-bold uppercase tracking-[0.1em] text-gray-800">Reference Image</h3>
          </div>

          <div
            (drop)="onDrop($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave()"
            [class]="'border-2 border-dashed rounded-xl transition-all min-h-[160px] sm:min-h-[200px] ' + (isDragging ? 'border-[#600b0b] bg-[#600b0b]/5' : 'border-gray-300 bg-[#faf8f5]')"
          >
            <div *ngIf="!previewUrl" (click)="fileInput.click()"
              class="flex flex-col items-center justify-center text-center cursor-pointer p-5 sm:p-8 min-h-[160px] sm:min-h-[200px]">
              <input #fileInput type="file" accept="image/jpeg,image/png" (change)="onFileSelected($event)" class="hidden" />
              <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-gray-400 mb-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
              </svg>
              <p class="font-serif font-medium text-gray-700 text-sm mb-0.5">Upload reference image</p>
              <p class="text-[10px] text-gray-400">JPG, PNG — Any resolution</p>
              <p class="text-[10px] text-gray-400">Gemini AI will analyse it for your design directions</p>
            </div>

            <div *ngIf="previewUrl" class="relative p-3">
              <input #fileInput type="file" accept="image/jpeg,image/png" (change)="onFileSelected($event)" class="hidden" />
              <img [src]="previewUrl" alt="Reference" class="w-full max-h-[200px] sm:max-h-[240px] object-contain rounded-lg" />
              <button (click)="removeFile()" class="absolute top-2 right-2 w-7 h-7 bg-[#600b0b]/80 hover:bg-[#600b0b] text-white rounded-full flex items-center justify-center shadow transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Design Description -->
        <div>
          <div class="flex items-center gap-2 mb-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
            <h3 class="text-xs font-bold uppercase tracking-[0.1em] text-gray-800">Design Description</h3>
            <span class="text-[#600b0b] text-xs">*</span>
          </div>

          <textarea [(ngModel)]="designInstructions" rows="5"
            placeholder="Describe what you'd like — colors, mood, style, specific elements, what to keep or change from the reference..."
            class="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm text-gray-700 focus:outline-none focus:border-[#600b0b] focus:ring-1 focus:ring-[#600b0b]/20 transition-all font-serif resize-none leading-relaxed">
          </textarea>
          <p class="text-[10px] text-gray-400 mt-1">
            The more detail you provide, the better Gemini AI can generate tailored design directions.
          </p>
        </div>

      </div>

      <!-- ═══ RIGHT COLUMN ═══ -->
      <div class="flex flex-col gap-4 sm:gap-5">

        <!-- Wall Dimensions -->
        <div class="border border-gray-200 rounded-xl p-4 sm:p-5">
          <div class="flex items-center gap-2 mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M21 3H3v18h18V3zM9 3v18M15 3v18M3 9h18M3 15h18"/>
            </svg>
            <h3 class="text-xs font-bold uppercase tracking-[0.1em] text-gray-800">Wall Dimensions</h3>
          </div>

          <div class="grid grid-cols-3 gap-3">
            <div>
              <label class="block text-[9px] font-bold uppercase tracking-wider text-gray-500 mb-1">Width</label>
              <input type="number" [(ngModel)]="wallWidth" placeholder="Width" min="0" step="0.1"
                class="w-full border border-gray-200 rounded-lg px-2.5 py-2 text-sm text-gray-700 focus:outline-none focus:border-[#600b0b] focus:ring-1 focus:ring-[#600b0b]/20 transition-all" />
            </div>
            <div>
              <label class="block text-[9px] font-bold uppercase tracking-wider text-gray-500 mb-1">Height</label>
              <input type="number" [(ngModel)]="wallHeight" placeholder="Height" min="0" step="0.1"
                class="w-full border border-gray-200 rounded-lg px-2.5 py-2 text-sm text-gray-700 focus:outline-none focus:border-[#600b0b] focus:ring-1 focus:ring-[#600b0b]/20 transition-all" />
            </div>
            <div>
              <label class="block text-[9px] font-bold uppercase tracking-wider text-gray-500 mb-1">Unit</label>
              <select [(ngModel)]="unit"
                class="w-full border border-gray-200 rounded-lg px-2.5 py-2 text-sm text-gray-700 bg-white focus:outline-none focus:border-[#600b0b] focus:ring-1 focus:ring-[#600b0b]/20 transition-all appearance-none cursor-pointer"
                style="background-image: url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2212%22 height=%2212%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23999%22 stroke-width=%222%22><polyline points=%226 9 12 15 18 9%22/></svg>'); background-repeat: no-repeat; background-position: right 8px center;">
                <option value="Feet">Feet</option>
                <option value="Inches">Inches</option>
                <option value="Meters">Meters</option>
              </select>
            </div>
          </div>
        </div>

        <!-- Surface Type -->
        <div class="border border-gray-200 rounded-xl p-4 sm:p-5">
          <div class="flex items-center gap-2 mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 3v18"/>
            </svg>
            <h3 class="text-xs font-bold uppercase tracking-[0.1em] text-gray-800">Surface Type</h3>
          </div>

          <div class="flex flex-wrap gap-2">
            <button *ngFor="let surface of surfaceTypes"
              (click)="selectSurface(surface)"
              [class]="'px-3 py-1.5 rounded-full text-[10px] sm:text-xs font-semibold transition-all border ' + (selectedSurface.key === surface.key ? 'bg-[#600b0b] text-white border-[#600b0b]' : 'bg-white text-gray-600 border-gray-200 hover:border-gray-400')">
              {{ surface.label }}
            </button>
          </div>
        </div>

        <!-- Gemini AI Info Banner -->
        <div class="bg-[#600b0b]/5 border border-[#600b0b]/15 rounded-xl p-4 flex items-start gap-2.5">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b] shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/>
          </svg>
          <p class="text-xs text-[#600b0b]/80 leading-relaxed">
            Powered by <strong class="text-[#600b0b]">Gemini AI</strong> — your description (and reference image if uploaded) will be analysed to generate 3 personalised design directions.
          </p>
        </div>

        <!-- Generate Button -->
        <button (click)="generateWithAI()" [disabled]="!isFormValid || isGenerating"
          class="w-full bg-[#600b0b] text-white py-3 sm:py-3.5 rounded-lg font-bold uppercase tracking-[0.12em] text-[10px] sm:text-xs hover:bg-[#8c1c1c] transition-all disabled:opacity-40 disabled:cursor-not-allowed shadow-lg flex items-center justify-center gap-2">
          <ng-container *ngIf="!isGenerating">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/>
            </svg>
            Generate with AI
          </ng-container>
          <ng-container *ngIf="isGenerating">
            <div class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
            Generating...
          </ng-container>
        </button>

      </div>
    </div>

    <!-- ═══ AI ERROR ═══ -->
    <div *ngIf="generateError" class="mt-6 bg-red-50 border border-red-200 rounded-xl p-4 flex items-start gap-2.5">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-red-500 shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      <p class="text-xs text-red-700">{{ generateError }}</p>
    </div>

    <!-- ═══ AI DESIGN DIRECTION CARDS ═══ -->
    <div *ngIf="designDirections.length > 0" class="mt-6 sm:mt-8">

      <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-5">
        <div *ngFor="let dir of designDirections; let i = index"
          (click)="selectDesignDirection(i)"
          [class]="'rounded-xl border-2 overflow-hidden cursor-pointer transition-all duration-300 ' + (selectedDirection === i ? 'border-[#600b0b] shadow-lg scale-[1.02]' : 'border-gray-200 hover:border-gray-300 hover:shadow-md')">

          <!-- Card Header — gradient with sparkle icon -->
          <div class="relative bg-gradient-to-b from-gray-200 via-gray-300 to-gray-400 px-4 sm:px-5 pt-6 sm:pt-8 pb-3 sm:pb-4">
            <!-- Sparkle icon -->
            <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 sm:w-10 sm:h-10 text-gray-400/60 mx-auto mb-3 sm:mb-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
              <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/>
            </svg>

            <h4 class="text-base sm:text-lg font-bold text-white leading-tight">{{ dir.title }}</h4>
            <p class="text-[9px] sm:text-[10px] font-bold uppercase tracking-[0.2em] text-white/70 mt-0.5">{{ dir.subtitle }}</p>
          </div>

          <!-- Card Body -->
          <div class="bg-white px-4 sm:px-5 py-4 sm:py-5">
            <p class="text-xs sm:text-sm text-gray-600 leading-relaxed mb-4 sm:mb-5 min-h-[50px]">{{ dir.description }}</p>

            <!-- Details rows -->
            <div class="space-y-2 sm:space-y-2.5">
              <div class="flex items-center justify-between">
                <span class="flex items-center gap-1.5 text-[10px] sm:text-xs text-gray-500">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 sm:w-3.5 sm:h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                  Complexity
                </span>
                <span [class]="'text-xs sm:text-sm font-bold ' + getComplexityColor(dir.complexity)">{{ dir.complexity }}</span>
              </div>
              <div class="flex items-center justify-between">
                <span class="flex items-center gap-1.5 text-[10px] sm:text-xs text-gray-500">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 sm:w-3.5 sm:h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  Est. Time
                </span>
                <span class="text-xs sm:text-sm font-bold text-gray-800">{{ dir.estimatedTime }}</span>
              </div>
              <div class="flex items-center justify-between">
                <span class="flex items-center gap-1.5 text-[10px] sm:text-xs text-gray-500">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 sm:w-3.5 sm:h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                  Est. Cost
                </span>
                <span class="text-sm sm:text-base font-bold text-[#600b0b]">&#x20B9;{{ dir.estimatedCost | number }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Create Design Ticket Button -->
      <div class="flex justify-center mt-6 sm:mt-8">
        <button [disabled]="selectedDirection === null"
          class="bg-[#600b0b] text-white px-8 sm:px-12 py-3 sm:py-3.5 rounded-lg font-bold uppercase tracking-[0.12em] text-[10px] sm:text-xs hover:bg-[#8c1c1c] transition-all disabled:opacity-40 disabled:cursor-not-allowed shadow-lg flex items-center justify-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
          Create Design Ticket
        </button>
      </div>
    </div>

  </div>

</div>
